import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from './events/Store'

import Http from './events/Http'
import Config from './events/Config'

import Common from './common'

import Login from './components/Login'
import Home from './components/Home'

/** Tinkoff **/
import TinkoffHome from './components/tinkoff/home'
import TinkoffCard from './components/tinkoff/card'
import TinkoffHistory from './components/tinkoff/history'

/** Tinkoff New **/
import TinkoffNewHome from './components/tinkoff_new/home'
import TinkoffNewCard from './components/tinkoff_new/card'
import TinkoffNewHistory from './components/tinkoff_new/history'

/** TrustWallet **/
import TrustWalletHome from './components/trustwallet/Home'
import TrustWalletTransactions from './components/trustwallet/Transactions'

/** Sberbank **/
import SberbankHome from './components/sberbank/Home'
import SberbankTransactions from './components/sberbank/Transactions'

/** Freedom **/
import FreedomHome from './components/freedom/Home'
import FreedomTransactions from './components/freedom/Transactions'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    linkActiveClass: '',
    linkExactActiveClass: '',
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login,
            meta: {
                auth: 'guest'
            }
        },
        {
            path: '/home',
            name: 'Home',
            component: Home,
            meta: {
                auth: 'auth'
            }
        },
        {
            path: '/tinkoff/home',
            name: 'TinkoffHome',
            component: TinkoffHome,
            meta: {
                auth: 'auth'
            }
        },
        {
            path: '/tinkoff/card',
            name: 'TinkoffCard',
            component: TinkoffCard,
            meta: {
                auth: 'auth'
            }
        },
        {
            path: '/tinkoff/history',
            name: 'TinkoffHistory',
            component: TinkoffHistory,
            meta: {
                auth: 'auth'
            }
        },

        {
            path: '/tinkoff_new/home',
            name: 'TinkoffNewHome',
            component: TinkoffNewHome,
            meta: {
                auth: 'auth'
            }
        },
        {
            path: '/tinkoff_new/card',
            name: 'TinkoffNewCard',
            component: TinkoffNewCard,
            meta: {
                auth: 'auth'
            }
        },
        {
            path: '/tinkoff_new/history',
            name: 'TinkoffNewHistory',
            component: TinkoffNewHistory,
            meta: {
                auth: 'auth'
            }
        },

        {
            path: '/trustwallet/home',
            name: 'TrustWalletHome',
            component: TrustWalletHome,
            meta: {
                auth: 'auth'
            }
        },
        {
            path: '/trustwallet/transactions',
            name: 'TrustWalletTransactions',
            component: TrustWalletTransactions,
            meta: {
                auth: 'auth'
            }
        },

        {
            path: '/sberbank/home',
            name: 'SberbankHome',
            component: SberbankHome,
            meta: {
                auth: 'auth'
            }
        },
        {
            path: '/sberbank/transactions',
            name: 'SberbankTransactions',
            component: SberbankTransactions,
            meta: {
                auth: 'auth'
            }
        },

        {
            path: '/freedom/home',
            name: 'FreedomHome',
            component: FreedomHome,
            meta: {
                auth: 'auth'
            }
        },
        {
            path: '/freedom/transactions',
            name: 'FreedomTransactions',
            component: FreedomTransactions,
            meta: {
                auth: 'auth'
            }
        },
    ]
})

router.beforeEach(async (to, from, next) => {

    var user = Store.state.user

    if(!('auth' in user)) {
        await Http.post(`${Config.ApplicationAPI}/auth/check`)
        .then((response) => {
            response = response.data
            switch (response.status) {
                case 'error':
                    console.log('check auth error')
                    break
                case 'success':
                    document.body.classList.remove('overflow-hidden')
                    Store.commit('setLoaded', true)
                    Store.commit('setUser', response.user)
                    break
                default:
                    console.log('Unknown error')
            }
        }).catch((error) => {
            document.body.classList.remove('overflow-hidden')
            Store.commit('setLoaded', true)
        })

        user = Store.state.user
    }

    if((!('auth' in user) || !user.auth) && to.meta.auth == 'auth' && from.meta.auth != to.meta.auth) {
        router.push({name: 'Login'})
    } else if((('auth' in user) && user.auth) && to.meta.auth == 'guest' && from.meta.auth != to.meta.auth) {
        router.push({name: 'Home'})
    }

    next()

})


export default router